<template>
    <div class="rounded-circle rounded-btn border box-shadow">
        <div class="d-flex h-100 justify-content-center">
            <div class="align-self-center">
                <slot><i class="fal fa-feather-alt"></i></slot>
            </div>
        </div>
        <slot name="notify"></slot>
    </div>
</template>

<script>
    export default {
        name: "circle-btn"
    }
</script>

<style lang="scss" scoped>
    .rounded-btn {
        background: var(--bs-primary);
        width: 50px;
        height: 50px;
        font-size: 20px;
        color: white;
        cursor: pointer;
    }
</style>
